module.exports = __webpack_public_path__ + "img/bg_4.7f242102.jpg";